'use client'

import Cookies from 'js-cookie'

/**
 * Client-side utility to get tenant ID from browser cookies
 */
export function getTenantIdFromBrowserCookies(): string {
  if (typeof window === 'undefined') {
    return 'understood'
  }

  return Cookies.get('tenant-id') || 'understood'
}
